const rawBackendUrl = process.env.REACT_APP_BACKEND_URL;

const normalizeUrl = (value) => {
  if (!value || value === 'undefined') {
    return null;
  }

  return value.replace(/\/+$/, '');
};

const getFallbackBaseUrl = () => {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }

  return '';
};

const backendUrl = normalizeUrl(rawBackendUrl);
const baseUrl = backendUrl || getFallbackBaseUrl();

if (typeof window !== 'undefined') {
  console.log('[API Config] REACT_APP_BACKEND_URL:', rawBackendUrl);
  console.log('[API Config] Resolved API base URL:', `${baseUrl}/api`);
}

if (!backendUrl && typeof window !== 'undefined') {
  console.error(
    'REACT_APP_BACKEND_URL is missing. Falling back to current origin for API requests.'
  );
}

const API_BASE_URL = `${baseUrl}/api`;

/**
 * Origin for links the backend must redirect to (OAuth return_url, shareable URLs).
 * Set REACT_APP_PUBLIC_APP_URL when the browser origin is wrong (e.g. ngrok, preview URL).
 */
export const getPublicAppBaseUrl = () => {
  const raw = (process.env.REACT_APP_PUBLIC_APP_URL || '').trim();
  if (raw && raw !== 'undefined') {
    return normalizeUrl(raw);
  }
  return getFallbackBaseUrl();
};

export default API_BASE_URL;
